


























import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import InputGroup from '@/mixins/form/inputGroup'
import { PatientContact } from '@/types/user'

const createNewContact = (): PatientContact => ({
  contactName: '',
  phoneNumber: '',
  relationship: ''
})

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue')
  }
})
export default class ContactInputGroup extends mixins(InputGroup) {
  @Prop({ type: Array, default: () => [] }) contacts!: Array<PatientContact>

  handleClickAdd() {
    this.contacts.push(createNewContact())
  }

  handleClickDelete(index: number) {
    this.contacts.splice(index, 1)
    this.$delete(this.validator.evaluators, `contactName${index}`)
    this.$delete(this.validator.evaluators, `relationship${index}`)
    this.$delete(this.validator.evaluators, `phoneNumber${index}`)
  }

  created() {
    if (this.contacts.length === 0) {
      this.contacts.push(createNewContact())
    }
  }
}
